import { merge, cloneDeep } from 'lodash'
import create from 'zustand'
import { State } from './interface'

export default create<State>((set) => ({
  register: { progress: 0 },
  passwordRecovery: {},
  update: (state: State) => {
    set((oldState) => cloneDeep(merge(oldState, state)))
  },
}))
